import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseResultChartComponent } from '../base-result-chart-component.directive';
import { peakPowerChartData, peakPowerChartOptions } from '../../chart-options';
import { NgChartsModule } from 'ng2-charts';
import { SharedModule } from '../../../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { PriceType } from '../../../../models/price/price';
import { CalculatorResult } from '../../../../models/analysis/solar-calculator-result';


@Component({
  selector: 'psc-peak-power-chart',
  standalone: true,
  imports: [CommonModule, NgChartsModule, SharedModule, TranslocoModule],
  templateUrl: './peak-power-chart.component.html'
})
export class PeakPowerChartComponent extends BaseResultChartComponent implements OnInit {

  @Input() advanced: boolean = false;

  protected readonly peakPowerChartData = peakPowerChartData();
  protected readonly peakPowerChartOptions = peakPowerChartOptions();

  get showChart(): boolean {
    return PeakPowerChartComponent.isPeakPowerChartShown(this.solarCalculatorResult);
  }

  static isPeakPowerChartShown(solarCalculatorResult: CalculatorResult) {
    return solarCalculatorResult.priceType === PriceType.ENTERPRISE && solarCalculatorResult.annualPowerPeakMoney !== null && solarCalculatorResult.annualPowerPeakMoney !== undefined;
  }

  override ngOnInit() {
    super.ngOnInit();
    /**
     * t(calculator_result.chart.without-solar, calculator_result.chart.with-solar)
     */
    this.subscribeToLabelTranslation('with-solar', this.peakPowerChartData.datasets[0]);
    this.subscribeToLabelTranslation('without-solar', this.peakPowerChartData.datasets[1]);

    this.subs.sink = this.resultChartsService.generateChartImageRequest.annualPeakPowerGraph.subscribe(
      () => {
        if (!this.showChart) {
          this.resultChartsService.chartImageGenerated.annualPeakPowerGraph.next(new Blob());
          return;
        }
        const hiddenChart = this.charts.get(1);

        hiddenChart?.chart?.canvas.toBlob(blob => {
          this.resultChartsService.chartImageGenerated.annualPeakPowerGraph.next(blob as Blob);
        }, 'image/png');

      },
    );
  }

  protected setChartData() {
    this.peakPowerChartData.datasets[0].data = this.solarCalculatorResult.monthlyResult.map(result => result.maxPeakPowerWithSolar);
    this.peakPowerChartData.datasets[1].data = this.solarCalculatorResult.monthlyResult.map(result => result.maxPeakPowerWithoutSolar);
  }

  protected readonly PriceType = PriceType;
}
